import angular from 'angular'
import SwatchContainer from 'emun.swatch/swatch-container'
import SwatchLanding from 'emun.swatch/swatch-landing'
import SwatchCounts from 'emun.swatch/swatch-counts'
import SwatchLists from 'emun.swatch/swatch-lists'
import Swatches from 'emun.swatch/swatches'
import SwatchCountEdit from 'emun.swatch/swatchcount-edit'
import SwatchCountHeader from 'emun.swatch/swatchcount-header'
import SwatchListEdit from 'emun.swatch/swatchlist-edit'
import SwatchListHeader from 'emun.swatch/swatchlist-header'
import SwatchCountListCards from 'emun.swatch/swatchcount-list-cards'
import SwatchCountListTable from 'emun.swatch/swatchcount-list-table'
import SwatchListCards from 'emun.swatch/swatch-list-cards'
import SwatchListTable from 'emun.swatch/swatch-list-table'
import SwatchesCards from 'emun.swatch/swatches-cards'
import SwatchesTable from 'emun.swatch/swatches-table'
import SwatchView from 'emun.swatch/swatch-view'
import SwatchScan from 'emun.swatch/swatch-scan'

const deps = [
	'emun.auth',
	'webutils',
	'webforms',
	'webmodals',
	'ui.router'];

export default angular.module('emun.swatch', deps)
	.component('swatchContainer', SwatchContainer)
	.component('swatchLanding', SwatchLanding)
	.component('swatchCounts', SwatchCounts)
	.component('swatchLists', SwatchLists)
	.component('swatches', Swatches)
	.component('swatchcountEdit', SwatchCountEdit)
	.component('swatchlistEdit', SwatchListEdit)
	.component('swatchcountHeader', SwatchCountHeader)
	.component('swatchlistHeader', SwatchListHeader)
	.component('swatchcountListCards', SwatchCountListCards)
	.component('swatchcountListTable', SwatchCountListTable)
	.component('swatchListCards', SwatchListCards)
	.component('swatchListTable', SwatchListTable)
	.component('swatchesCards', SwatchesCards)
	.component('swatchesTable', SwatchesTable)
	.component('swatchView', SwatchView)
	.component('swatchScan', SwatchScan)
	//.component('countEdit', CountEdit)
	//.component('countView', CountView)
	.name;